import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 50px;
  align-items: center;

  ${({ theme }) => theme.media.mobile} {
    flex-wrap: wrap;
    align-content: space-between;
    padding: 20px 15px;
    height: 98px;
  }

  > div {
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    :after {
      background-color: ${({ theme }) => theme.colors.gray300};
      display: block;
      content: '';
      height: 16px;
    }

    ${({ theme }) => theme.media.pc} {
      :nth-child(2) {
        padding-right: 25%;
      }
      :nth-child(4) {
        padding-right: 30px;
      }
    }

    ${({ theme }) => theme.media.mobile} {
      :nth-child(3) {
        width: 100%;
      }

      :nth-child(4) {
        width: 63px;
      }
    }
  }
`;
